// Session 55.ag · Payment cancelled page.
import { Link } from "react-router-dom";
import AppShell from "../components/AppShell";

export default function PaymentCancel() {
  return (
    <AppShell>
      <div className="m-page-pad" data-testid="payment-cancel-page" style={{maxWidth:640, textAlign:"center"}}>
        <span className="m-eyebrow">No charge</span>
        <h1 className="m-h1">Checkout <em>cancelled</em></h1>
        <p className="m-muted" style={{marginTop:8}}>
          Your card was not charged. Try again whenever you&apos;re ready.
        </p>
        <div style={{marginTop:26, display:"flex", gap:12, justifyContent:"center"}}>
          <Link to="/membership" data-testid="payment-cancel-retry"
            style={{padding:"12px 26px", background:"#B8913A", color:"#FAF8F3", borderRadius:999, textDecoration:"none", fontSize:14}}>
            Back to plans
          </Link>
          <Link to="/"
            style={{padding:"12px 26px", background:"transparent", color:"#1B2340", border:"1px solid rgba(27,35,64,0.35)", borderRadius:999, textDecoration:"none", fontSize:14}}>
            Home
          </Link>
        </div>
      </div>
    </AppShell>
  );
}
